import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isTokenExpired } from "../utils/tokenExpiry";
import { showTokenExpiryPopUp } from "../components/SweatAlert";
import { useEffect, useState } from "react";

const ProtectedRoute = () => {
  const location = useLocation();
  const [allow, setAllow] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("x_t");
      const isAuthenticated = !!token && !isTokenExpired();

      if (!isAuthenticated) {
        const is401 = await showTokenExpiryPopUp();
        if (is401) {
          localStorage.removeItem("x_u");
          localStorage.removeItem("x_t");
          setAllow(false);
        } else {
          setAllow(false);
        }
      } else {
        setAllow(true);
      }
    };

    checkAuth();
  }, []);

  if (allow === null) return null;

  if (!allow) {
    return <Navigate to="/sign-in" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
